import { render, staticRenderFns } from "./TabCategoryItem.vue?vue&type=template&id=398fec20"
import script from "./TabCategoryItem.vue?vue&type=script&lang=js"
export * from "./TabCategoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports